import React, { ReactElement, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import '@philips-internal/oswald-ui-components';
import '@philips-emr/referring-physician-components';

import { Foundation } from '@philips-internal/oswald-ui-foundation';
import bootstrap from './app/bootstrap-foundation';
import './controllers';
import Audit from './app/audit';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services';

function RootApp(): ReactElement {
  const bootstrapPromise = bootstrap;

  useEffect(() => {
    const audit = new Audit();
    audit.routeChangeLog(HistoryService.getCurrentRoute());
    audit.addRouteListener();
  });

  return (
    <Foundation
      bootstrap={bootstrapPromise}
      root={{
        fragmentName: 'app',
      }}
    />
  );
}

const container = document.getElementById('root') || document.body;
const root = createRoot(container);
root.render(<RootApp/>);